module.exports = __webpack_public_path__ + "fonts/Lato-Regular.2d36b1a9.ttf";